import { listenTenant } from '../../models/Tenant';
import ObservableComponent from './ObservableComponent';

export default class BaseTenantComponent<P = {}, S = {}> extends ObservableComponent<P, S> {
    componentDidMount(): void {
        this._unlisten.push(listenTenant(() => this.forceUpdate()));
    }
}